import {AxiosError} from 'axios';
import {GET_COORDINATOR_APPEAL_CONFIRM_AND_PAY_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ConfirmAndPayResponse {
  internalTransactionRef: string;
  transactionAmount: number;
  paymentSuccess: boolean;
}

export interface ConfirmAndPayRequest {
  uuid: string;
  paymentMode: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: ConfirmAndPayResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCoordinatorAppealConfirmAndPay = ({onSuccess, onError}: Input = {}) => {
  const postCoordinatorAppealConfirmAndPay = async (requestBody: ConfirmAndPayRequest) => {
    const res = await axiosClient.post<ConfirmAndPayResponse>(
        GET_COORDINATOR_APPEAL_CONFIRM_AND_PAY_URL,
        requestBody
    );

    return res.data;
  };

  return useCustomMutation(postCoordinatorAppealConfirmAndPay, {
    onSuccess,
    onError,
  });
};
